<template>
  <div class="flex justify-between py-1">
    <span class="text-body-2 text-grey-darken-1">
      {{ label }}<slot name="badge" />
    </span>
    <slot name="value" />
  </div>
</template>

<script setup lang="ts">
defineProps<{ label: string }>();
</script>
